import type { SVGProps } from 'react';
export const Lock = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M14.92 7.67h-2.17V6.1c0-.82-.34-1.62-.95-2.2a3.33 3.33 0 0 0-4.6 0c-.6.58-.95 1.38-.95 2.2v1.56H4.08c-.28 0-.56.1-.76.3Q3 8.28 3 8.7v7.26q0 .43.32.74.32.3.76.3h10.84c.28 0 .56-.1.76-.3q.31-.31.32-.74V8.7c0-.27-.11-.54-.32-.73-.2-.2-.48-.3-.76-.3M7.33 6.1c0-.55.23-1.08.64-1.47a2.2 2.2 0 0 1 3.06 0c.4.4.64.92.64 1.47v1.56H7.33zm7.59 9.85H4.08V8.7h10.84z" />
  </svg>
);
